module.exports = __webpack_public_path__ + "static/outlook_2003-4d57f95a4bf5fc5bda54409c0d20544a.png";